module.exports = __webpack_public_path__ + "img/Fortune-Greece.04ebed50.png";